module.exports = __webpack_public_path__ + "img/mortgage-protection.d2b8497.svg";